import { render } from "./OutraPublicacaoView.vue?vue&type=template&id=a2f19bfa&scoped=true"
import script from "./OutraPublicacaoView.vue?vue&type=script&lang=js"
export * from "./OutraPublicacaoView.vue?vue&type=script&lang=js"

import "./OutraPublicacaoView.vue?vue&type=style&index=0&id=a2f19bfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2f19bfa"]])

export default __exports__